export const GET_CLIENT_CONFIG = 'GET_CLIENT_CONFIG';
export const CLIENT_CONFIG_LOADING = 'CLIENT_CONFIG_LOADING';
export const CLIENT_CONFIG_SUCCESS = 'CLIENT_CONFIG_SUCCESS';
export const CLIENT_CONFIG_FAILURE = 'CLIENT_CONFIG_FAILURE';

export type Actions = {
  GET_CLIENT_CONFIG: { type: typeof GET_CLIENT_CONFIG; payload: string };
  CLIENT_CONFIG_LOADING: { type: typeof CLIENT_CONFIG_LOADING; payload: any };
  CLIENT_CONFIG_SUCCESS: { type: typeof CLIENT_CONFIG_SUCCESS; payload: any };
  CLIENT_CONFIG_FAILURE: { type: typeof CLIENT_CONFIG_FAILURE; payload: any };
};

export const actionCreators = {
  getClientConfig: (magCode: string): Actions[typeof GET_CLIENT_CONFIG] => ({
    type: GET_CLIENT_CONFIG,
    payload: magCode,
  }),
  clientConfigLoading: (
    payload: boolean,
  ): Actions[typeof CLIENT_CONFIG_LOADING] => ({
    type: CLIENT_CONFIG_LOADING,
    payload,
  }),
  clientConfigSuccess: (
    clientConfig: any,
  ): Actions[typeof CLIENT_CONFIG_SUCCESS] => ({
    type: CLIENT_CONFIG_SUCCESS,
    payload: clientConfig,
  }),
  clientConfigFailure: (err: any): Actions[typeof CLIENT_CONFIG_FAILURE] => ({
    type: CLIENT_CONFIG_FAILURE,
    payload: err,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/main/actions.ts